import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import PasatiemposLeaderboard from './PasatiemposLeaderboard';
export default class QuienDijoGame extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "hasStarted", false);
    _defineProperty(this, "submitting", false);
    _defineProperty(this, "sessionId", '');
    _defineProperty(this, "currentStreak", 0);
    _defineProperty(this, "round", null);
    // Lifeline States
    _defineProperty(this, "lifelines", {
      fifty_fifty: true,
      audience: true,
      phone: true
    });
    _defineProperty(this, "eliminatedUserIds", []);
    _defineProperty(this, "audienceVotes", null);
    _defineProperty(this, "phoneAdvice", null);
    _defineProperty(this, "lifelineLoading", null);
    // Guess Selection & Feedback State
    _defineProperty(this, "selectedCandidateId", null);
    _defineProperty(this, "isRevealing", false);
    _defineProperty(this, "roundResult", null);
    // Game Over State
    _defineProperty(this, "isGameOver", false);
    _defineProperty(this, "gameOverData", null);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = false;
  }
  startNewGame() {
    this.loading = true;
    this.hasStarted = true;
    this.isGameOver = false;
    this.gameOverData = null;
    this.currentStreak = 0;
    this.sessionId = '';
    this.audienceVotes = null;
    this.phoneAdvice = null;
    this.eliminatedUserIds = [];
    this.selectedCandidateId = null;
    this.roundResult = null;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/quien-dijo/round'
    }).then(response => {
      this.handleNewRoundResponse(response);
      this.loading = false;
      m.redraw();
    }).catch(err => {
      this.loading = false;
      app.alerts.show({
        type: 'error'
      }, 'Error al cargar la cita del foro. Inténtalo de nuevo.');
      m.redraw();
    });
  }
  handleNewRoundResponse(response) {
    this.round = response;
    this.sessionId = response.session_id;
    this.currentStreak = response.current_streak;
    this.lifelines = response.lifelines;
    this.eliminatedUserIds = response.eliminated_candidates || [];
    this.audienceVotes = null;
    this.phoneAdvice = null;
    this.selectedCandidateId = null;
    this.isRevealing = false;
    this.roundResult = null;

    // Clear mobile tap focus to avoid stuck selected/hover styling
    if (typeof document !== 'undefined' && document.activeElement && 'blur' in document.activeElement) {
      document.activeElement.blur();
    }
  }
  useLifeline(type) {
    if (!this.sessionId || !this.lifelines[type] || this.lifelineLoading || this.isRevealing || this.submitting) {
      return;
    }
    this.lifelineLoading = type;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/nagusi/games/quien-dijo/lifeline',
      body: {
        session_id: this.sessionId,
        lifeline: type
      }
    }).then(res => {
      this.lifelines = res.lifelines || this.lifelines;
      this.lifelines[type] = false;
      if (type === 'fifty_fifty') {
        this.eliminatedUserIds = res.eliminated_user_ids || [];
      } else if (type === 'audience') {
        this.audienceVotes = res.votes || null;
      } else if (type === 'phone') {
        this.phoneAdvice = res.call || null;
      }
      this.lifelineLoading = null;
      m.redraw();
    }).catch(err => {
      this.lifelineLoading = null;
      const msg = err && err.response && err.response.error || 'No se pudo activar el comodín.';
      app.alerts.show({
        type: 'error'
      }, msg);
      m.redraw();
    });
  }
  submitGuess(candidateId) {
    if (this.submitting || this.isRevealing || !this.sessionId || this.isGameOver) {
      return;
    }
    if (this.eliminatedUserIds.includes(candidateId)) {
      return;
    }
    this.selectedCandidateId = candidateId;
    this.submitting = true;
    this.isRevealing = true;
    m.redraw();

    // Dramatic brief pause before revealing server response (quiz show style)
    setTimeout(() => {
      app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/nagusi/games/quien-dijo/answer',
        body: {
          session_id: this.sessionId,
          selected_user_id: candidateId
        }
      }).then(res => {
        this.submitting = false;
        if (res.is_correct) {
          this.roundResult = {
            isCorrect: true,
            selectedId: candidateId,
            correctId: candidateId
          };
          this.currentStreak = res.current_streak;
          m.redraw();

          // Advance to next round smoothly after 1.2s of celebration
          setTimeout(() => {
            this.handleNewRoundResponse(res.round);
            m.redraw();
          }, 1200);
        } else {
          var _res$correct_user;
          // Game Over
          this.roundResult = {
            isCorrect: false,
            selectedId: candidateId,
            correctId: (_res$correct_user = res.correct_user) == null ? void 0 : _res$correct_user.id
          };
          m.redraw();
          setTimeout(() => {
            this.isGameOver = true;
            this.gameOverData = {
              finalStreak: res.final_streak,
              correctUser: res.correct_user,
              postUrl: res.post_url,
              discussionTitle: res.discussion_title
            };
            this.isRevealing = false;
            m.redraw();
          }, 1500);
        }
      }).catch(err => {
        this.submitting = false;
        this.isRevealing = false;
        const msg = err && err.response && err.response.error || 'Error al validar la respuesta.';
        app.alerts.show({
          type: 'error'
        }, msg);
        m.redraw();
      });
    }, 700);
  }
  view() {
    if (!this.hasStarted) {
      return this.renderStartLobby();
    }
    if (this.isGameOver && this.gameOverData) {
      return this.renderGameOver();
    }
    if (this.loading || !this.round) {
      return m("div", {
        className: "quien-dijo-loading"
      }, m(LoadingIndicator, null), m("p", null, "Buscando una cita memorable en el foro..."));
    }
    return this.renderGameView();
  }
  renderStartLobby() {
    return m("div", {
      className: "quien-dijo-container"
    }, m("div", {
      className: "quien-dijo-lobby"
    }, m("div", {
      className: "lobby-badge"
    }, m("i", {
      className: "fas fa-quote-left"
    }), " Nuevo Pasatiempo"), m("h2", null, "\xBFQui\xE9n dijo...? Citas C\xE9lebres del Foro"), m("p", {
      className: "lobby-desc"
    }, "Pon a prueba tu agilidad y memoria forera. Te mostramos un comentario real publicado en el foro junto con el hilo y la fecha. \xBFSer\xE1s capaz de adivinar qu\xE9 forero lo escribi\xF3 en modo ", m("strong", null, "muerte s\xFAbita"), "?"), m("div", {
      className: "lobby-rules-grid"
    }, m("div", {
      className: "rule-card"
    }, m("div", {
      className: "rule-icon flame"
    }, m("i", {
      className: "fas fa-fire-alt"
    })), m("div", {
      className: "rule-text"
    }, m("strong", null, "Muerte S\xFAbita"), m("span", null, "Un solo fallo y se termina la partida. \xBFCu\xE1ntas rondas aguantar\xE1s?"))), m("div", {
      className: "rule-card"
    }, m("div", {
      className: "rule-icon"
    }, m("strong", null, "50%")), m("div", {
      className: "rule-text"
    }, m("strong", null, "Comod\xEDn del 50%"), m("span", null, "Elimina 2 opciones incorrectas dej\xE1ndote solo la correcta y un rival."))), m("div", {
      className: "rule-card"
    }, m("div", {
      className: "rule-icon"
    }, m("i", {
      className: "fas fa-users"
    })), m("div", {
      className: "rule-text"
    }, m("strong", null, "Comod\xEDn del P\xFAblico"), m("span", null, "La grada forera vota por porcentajes. Cuanto m\xE1s activo sea el forero y reciente el post, \xA1m\xE1s seguro votar\xE1!"))), m("div", {
      className: "rule-card"
    }, m("div", {
      className: "rule-icon"
    }, m("i", {
      className: "fas fa-phone-alt"
    })), m("div", {
      className: "rule-text"
    }, m("strong", null, "Comod\xEDn de la Llamada"), m("span", null, "Llama a otro forero para pedirle consejo... si no se corta la llamada.")))), m("div", {
      className: "lobby-alert-note"
    }, m("i", {
      className: "fas fa-info-circle"
    }), " Tienes ", m("strong", null, "un solo uso de cada comod\xEDn para toda la partida"), ". \xA1Admin\xEDstralos bien!"), m("div", {
      className: "lobby-actions"
    }, m(Button, {
      className: "Button Button--primary Button--large btn-start-game",
      onclick: () => this.startNewGame()
    }, m("i", {
      className: "fas fa-play"
    }), " \xA1Empezar Partida!")), m("div", {
      className: "quien-dijo-ranking-section"
    }, m("h3", null, m("i", {
      className: "fas fa-trophy"
    }), " R\xE9cord de Rachas en el Foro"), m(PasatiemposLeaderboard, {
      game: "quien_dijo",
      initialFilter: "quien_dijo"
    }))));
  }
  renderGameView() {
    const round = this.round;
    const letters = ['A', 'B', 'C', 'D'];
    return m("div", {
      className: "quien-dijo-container"
    }, m("div", {
      className: "quien-dijo-game-header"
    }, m("div", {
      className: "streak-indicator"
    }, m("span", {
      className: "streak-icon"
    }, m("i", {
      className: "fas fa-fire-alt"
    })), m("div", {
      className: "streak-info"
    }, m("span", {
      className: "streak-label"
    }, "Racha actual"), m("span", {
      className: "streak-value"
    }, this.currentStreak, " ", this.currentStreak === 1 ? 'acierto' : 'aciertos'))), m("div", {
      className: "lifelines-bar"
    }, m("button", {
      type: "button",
      className: "lifeline-btn ".concat(!this.lifelines.fifty_fifty ? 'used' : '', " ").concat(this.lifelineLoading === 'fifty_fifty' ? 'loading' : ''),
      disabled: !this.lifelines.fifty_fifty || this.isRevealing || !!this.lifelineLoading,
      onclick: () => this.useLifeline('fifty_fifty'),
      title: "Comod\xEDn del 50%: Elimina 2 opciones incorrectas"
    }, m("span", {
      className: "lifeline-title"
    }, "50%"), m("span", {
      className: "lifeline-status"
    }, this.lifelines.fifty_fifty ? 'Disponible' : 'Usado')), m("button", {
      type: "button",
      className: "lifeline-btn ".concat(!this.lifelines.audience ? 'used' : '', " ").concat(this.lifelineLoading === 'audience' ? 'loading' : ''),
      disabled: !this.lifelines.audience || this.isRevealing || !!this.lifelineLoading,
      onclick: () => this.useLifeline('audience'),
      title: "Comod\xEDn del P\xFAblico: Conoce los porcentajes de voto del foro"
    }, m("span", {
      className: "lifeline-title"
    }, m("i", {
      className: "fas fa-users"
    }), " P\xFAblico"), m("span", {
      className: "lifeline-status"
    }, this.lifelines.audience ? 'Disponible' : 'Usado')), m("button", {
      type: "button",
      className: "lifeline-btn ".concat(!this.lifelines.phone ? 'used' : '', " ").concat(this.lifelineLoading === 'phone' ? 'loading' : ''),
      disabled: !this.lifelines.phone || this.isRevealing || !!this.lifelineLoading,
      onclick: () => this.useLifeline('phone'),
      title: "Comod\xEDn de la Llamada: Consulta la opini\xF3n de un contacto forero"
    }, m("span", {
      className: "lifeline-title"
    }, m("i", {
      className: "fas fa-phone-alt"
    }), " Llamada"), m("span", {
      className: "lifeline-status"
    }, this.lifelines.phone ? 'Disponible' : 'Usado')))), this.phoneAdvice && m("div", {
      className: "phone-advice-bubble ".concat(this.phoneAdvice.status)
    }, m("div", {
      className: "bubble-icon"
    }, m("i", {
      className: "fas fa-phone-volume"
    })), m("div", {
      className: "bubble-content"
    }, m("strong", null, "Llamada telef\xF3nica con un forero:"), m("p", null, "\"", this.phoneAdvice.message, "\""))), m("div", {
      className: "quien-dijo-quote-card"
    }, m("div", {
      className: "quote-icon-watermark"
    }, m("i", {
      className: "fas fa-quote-left"
    })), m("blockquote", {
      className: "quote-text"
    }, "\"", round.quote, "\""), m("div", {
      className: "quote-meta-row"
    }, m("span", {
      className: "quote-meta-item thread"
    }, m("i", {
      className: "fas fa-comments"
    }), " ", m("strong", null, "Hilo:"), " ", round.discussion_title), m("span", {
      className: "quote-meta-item date"
    }, m("i", {
      className: "fas fa-calendar-alt"
    }), " ", m("strong", null, "Fecha:"), " ", round.post_date))), m("div", {
      className: "candidates-prompt"
    }, m("i", {
      className: "fas fa-question-circle"
    }), " \xBFQui\xE9n escribi\xF3 este comentario?"), m("div", {
      className: "candidates-grid"
    }, round.candidates.map((cand, idx) => {
      var _this$audienceVotes$c;
      const letter = letters[idx] || '•';
      const isEliminated = this.eliminatedUserIds.includes(cand.id);
      const isSelected = this.selectedCandidateId === cand.id;
      const audiencePct = this.audienceVotes ? (_this$audienceVotes$c = this.audienceVotes[cand.id]) != null ? _this$audienceVotes$c : 0 : null;
      let cardClass = 'candidate-card';
      if (isEliminated) {
        cardClass += ' eliminated';
      }
      if (isSelected && this.isRevealing && !this.roundResult) {
        cardClass += ' checking';
      }
      if (this.roundResult) {
        if (cand.id === this.roundResult.correctId) {
          cardClass += ' correct';
        } else if (isSelected && !this.roundResult.isCorrect) {
          cardClass += ' wrong';
        }
      }
      return m("button", {
        key: "round-".concat(this.currentStreak, "-candidate-").concat(cand.id),
        type: "button",
        className: cardClass,
        disabled: isEliminated || this.isRevealing,
        onclick: () => this.submitGuess(cand.id)
      }, m("span", {
        className: "option-letter"
      }, letter), m("div", {
        className: "candidate-avatar"
      }, cand.avatar_url ? m("img", {
        src: cand.avatar_url,
        alt: cand.username
      }) : m("span", {
        className: "avatar-placeholder"
      }, cand.username.charAt(0).toUpperCase())), m("div", {
        className: "candidate-name-box"
      }, m("span", {
        className: "candidate-name"
      }, "@", cand.username), audiencePct !== null && !isEliminated && m("div", {
        className: "audience-pct-box"
      }, m("div", {
        className: "audience-pct-bar",
        style: {
          width: "".concat(audiencePct, "%")
        }
      }), m("span", {
        className: "audience-pct-label"
      }, audiencePct, "% de votos"))), isEliminated && m("span", {
        className: "eliminated-badge"
      }, m("i", {
        className: "fas fa-times"
      })), this.roundResult && cand.id === this.roundResult.correctId && m("span", {
        className: "feedback-badge check"
      }, m("i", {
        className: "fas fa-check"
      })), this.roundResult && isSelected && !this.roundResult.isCorrect && m("span", {
        className: "feedback-badge cross"
      }, m("i", {
        className: "fas fa-times"
      })));
    })));
  }
  renderGameOver() {
    const data = this.gameOverData;
    return m("div", {
      className: "quien-dijo-container"
    }, m("div", {
      className: "quien-dijo-gameover"
    }, m("div", {
      className: "gameover-badge"
    }, m("i", {
      className: "fas fa-skull-crossbones"
    }), " Fin de la Partida"), m("h2", null, "\xA1Muerte S\xFAbita!"), m("p", {
      className: "gameover-streak-lead"
    }, "Has conseguido una racha de ", m("strong", null, data.finalStreak), " ", data.finalStreak === 1 ? 'acierto consecutivo' : 'aciertos consecutivos', "."), data.correctUser && m("div", {
      className: "revealed-author-card"
    }, m("span", {
      className: "card-hint"
    }, "El autor real del comentario era:"), m("div", {
      className: "revealed-user-row"
    }, m("div", {
      className: "author-avatar"
    }, data.correctUser.avatar_url ? m("img", {
      src: data.correctUser.avatar_url,
      alt: data.correctUser.username
    }) : m("span", {
      className: "avatar-placeholder"
    }, data.correctUser.username.charAt(0).toUpperCase())), m("div", {
      className: "author-name-box"
    }, m("strong", {
      className: "author-name"
    }, "@", data.correctUser.username), m("span", {
      className: "thread-link-sub"
    }, "En el debate: ", m("em", null, data.discussionTitle)))), data.postUrl && m("a", {
      href: data.postUrl,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "Button Button--link btn-view-post"
    }, m("i", {
      className: "fas fa-external-link-alt"
    }), " Ver el comentario original en el foro")), m("div", {
      className: "gameover-actions"
    }, m(Button, {
      className: "Button Button--primary Button--large",
      onclick: () => this.startNewGame()
    }, m("i", {
      className: "fas fa-redo-alt"
    }), " Jugar Otra Partida")), m("div", {
      className: "quien-dijo-ranking-section"
    }, m("h3", null, m("i", {
      className: "fas fa-trophy"
    }), " Tabla de Clasificaci\xF3n"), m(PasatiemposLeaderboard, {
      game: "quien_dijo",
      initialFilter: "quien_dijo"
    }))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/pasatiempos/QuienDijoGame', QuienDijoGame);